import { useState, useEffect } from 'react'
import {
  Stack,
  Button,
  Text,
  Image,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
  DrawerBody,
  List,
  ListItem,
  ListIcon,
  InputGroup,
  Input,
  InputRightElement
} from '@chakra-ui/react'
import { CheckIcon, SearchIcon } from '@chakra-ui/icons'

import useDistributor from '../hooks/useDistributor'

import ReturnDrawerMobile from './ReturnDrawerMobile'
import useAuth from '../hooks/useAuth'

const ListDistributor = ({ title, sizeS, survey, setSurvey }) => {
  const { userRegister } = useAuth()
  const { preferences } = userRegister
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState('')
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [size, setSize] = useState('')
  const [distributors] = useDistributor()

  const quilmesImages = require.context('../assets/images', true)

  useEffect(() => {
    if (preferences === null) {
      return
    }
    setSelected(preferences.distributor.description)
  }, [preferences])
  /**
   * It takes a newSize as an argument, sets the size to the newSize, and then calls the onOpen
   * function
   * @param newSize - The new size of the modal.
   */
  const handleClick = (newSize) => {
    setSize(newSize)
    onOpen()
  }

  /**
   * It sets the selected value to the newSelected value and sets the survey object to the newSelected
   * value.
   * @param newSelected - The new selected value
   */
  const handleSelect = (newSelected) => {
    setSelected(newSelected)
    setSurvey({ ...survey, distributor: newSelected })
  }

  /* Filtering the distributors array based on the search input. */
  const filter = distributors.filter((item) => {
    if (search === '') {
      return item
    } else {
      return item.description.toLowerCase().includes(search.toLowerCase())
    }
  })

  const { distributor } = survey

  return (
    <Stack>
      <Button
        key={size}
        display={'flex'}
        fontWeight={500}
        justifyContent={'space-between'}
        variant='outline'
        onClick={() => handleClick(sizeS)}
      >
        <Text>{distributor === '' ? `${title} *` : distributor} </Text>
        <Image src={quilmesImages('./Vector.svg')} width={'12px'} />
      </Button>

      <Drawer isOpen={isOpen} maxWidth={'100%'} size={sizeS} onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <ReturnDrawerMobile onClose={onClose} />
          <DrawerBody paddingTop={10}>
            <InputGroup borderRadius={'none'}>
              <InputRightElement
                bgColor={'whiteAlpha.100'}
                border={'none'}
                borderRadius={'none'}
              >
                <SearchIcon color='blackAlpha.500' />
              </InputRightElement>
              <Input
                className='search-input'
                placeholder='Buscar'
                type='text'
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </InputGroup>

            <List paddingTop={'2rem'} spacing={4}>
              {filter
                .sort((a, b) =>
                  a.description.toLowerCase() < b.description.toLowerCase()
                    ? -1
                    : 1
                ).map((item) => (
                  item.bottler !== null && item.geoArea !== null
                    ? item.geoArea.hasProducts === true
                      ? <ListItem
                        key={item.distributorId}
                        display={'flex'}
                        justifyContent={'space-between'}
                        textTransform={'capitalize'}
                        value={item.description}
                        onClick={() => handleSelect(item.description)}
                        {...(selected === item.description
                          ? { color: '#DB580B' }
                          : {})}
                      >
                        {item.description}
                        {selected === item.description && (
                        <ListIcon
                          as={CheckIcon}
                          color={'#DB580B'}
                          marginTop={'.3rem'}
                        />
                        )}
                      </ListItem>
                      : null
                    : null
                ))}
            </List>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Stack>
  )
}

export default ListDistributor
